<template>
    <div class="toggle-list-view">
        <div
            role="button"
            @click="toggleListView = false"
            @keyup.enter="toggleListView = false"
            tabindex="0"
            :class="['toggle-list-view__button', { 'toggle-list-view__button-active': !toggleListView }]"
        >
            <span class="icon icon-grid"></span>
            <span v-html="$t('General.grid')"></span>
        </div>
        <div
            role="button"
            @click="toggleListView = true"
            @keyup.enter="toggleListView = true"
            tabindex="0"
            :class="['toggle-list-view__button', { 'toggle-list-view__button-active': toggleListView }]"
        >
            <span class="icon icon-listview"></span>
            <span v-html="$t('General.list')"></span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'CourseListViewToggle',
        data () {
            return {
                toggleListView: false
            }
        },
        computed: {
            toggleLabel () {
                return this.toggleListView ? this.$t('CourseListFilter.toggle_list_view_vertical') : this.$t('CourseListFilter.toggle_list_view_mosaic')
            },
            ...mapGetters({
                hasListViewBeenToggled: 'getListViewToggleState'
            })
        },
        watch: {
            toggleListView () {
                this.$store.dispatch('toggleListView', this.toggleListView)
            }
        },
        mounted () {
            if (this.hasListViewBeenToggled !== this.toggleListView) {
                this.toggleListView = this.hasListViewBeenToggled
            }
        }
    }
</script>
<style lang="scss" scoped>
  .toggle-list-view {
      border-radius: 10px;
      background: $white;
      display: inline-flex;
      height: 48px;
      padding: 0 7px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;

      &__button {
          color: $tuatara;
          border-radius: 10px;
          display: flex;
          padding: 7px 10px;
          justify-content: center;
          align-items: center;
          gap: 6px;
          cursor: pointer;
          line-height: 1.8rem;
      }

      &__button-active {
          background: $lavender;
          color: $white;
      }
  }
</style>
